import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20scene%20with%20paparazzi%20flash%20lights%2C%20red%20carpet%20event%20atmosphere%2C%20crowd%20of%20reporters%20with%20cameras%2C%20glamorous%20yet%20chaotic%20vibe%2C%20dark%20background%20with%20warm%20spotlights%2C%20cinematic%20photography%2C%20soft%20bokeh%20effect%2C%20luxurious%20and%20dramatic%20composition%2C%20celebrity%20culture%20theme%2C%20high%20contrast%20lighting&width=1920&height=900&seq=hero-main-bg&orientation=landscape"
        alt="51吃瓜每日大赛 - 娱乐八卦爆料平台"
        title="51吃瓜每日大赛 - 汇集全网热门吃瓜爆料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="w-full max-w-3xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight mb-4">
            全网热点
          </h1>
          <p className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white/90 leading-tight mb-4">
            每日更新
          </p>
          <p className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-white/80 leading-tight mb-10">
            吃瓜一站达
          </p>

          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-1/2">
              <p className="text-sm md:text-base text-white/70 leading-relaxed">
                汇集全网热门吃瓜爆料与黑料视频，覆盖明星翻车、网红塌房、企业内幕等最新大瓜。每日不间断更新，让你不错过每一个热议话题。
              </p>
            </div>
            <div className="md:w-1/2 flex items-end">
              <div className="flex items-center gap-4 text-white/60">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">10w+</div>
                  <div className="text-xs md:text-sm">每日活跃瓜友</div>
                </div>
                <div className="w-px h-8 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">24h</div>
                  <div className="text-xs md:text-sm">实时滚动更新</div>
                </div>
                <div className="w-px h-8 bg-white/20"></div>
                <Link to="/category/shishi-baoliao" className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-label text-sm rounded-full transition-colors whitespace-nowrap">
                  立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}